import type { QueryClient } from '@tanstack/react-query';

/**
 * Сбросить кэш всех запросов под путём API. Ключи orval — строки URL
 * (`/api/v1/products`, `/api/v1/products/5`), поэтому префикс сравнивается по строке:
 * обычное сравнение ключей-массивов не считает второй «внутри» первого.
 *
 * Сначала отменяем незавершённые запросы: запрос без данных, начатый до изменения,
 * TanStack при сбросе не перезапускает — отдал бы ответ без только что созданной записи
 * (загрузили УПД, пока грузилась вкладка «Все», — документ не появлялся до перезагрузки).
 */
export async function invalidatePath(queryClient: QueryClient, prefix: string): Promise<void> {
  const filters = {
    predicate: (q: { queryKey: readonly unknown[] }) =>
      typeof q.queryKey[0] === 'string' && q.queryKey[0].startsWith(prefix),
  };
  await queryClient.cancelQueries(filters);
  await queryClient.invalidateQueries(filters);
}
